<template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('NAME')">
          <inputvalidation :formerror="formError" name="name">
            <b-form-input type="text" v-model="formData.name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('SURNAME')">
          <inputvalidation :formerror="formError" name="surname">
            <b-form-input type="text" v-model="formData.surname"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('CONTACTNUMBER')">
          <inputvalidation :formerror="formError" name="contactNumber">
            <b-form-input type="text" v-model="formData.contactNumber"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('EMAIL')">
          <inputvalidation :formerror="formError" name="email">
            <b-form-input type="email" v-model="formData.email"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ParentsForm',
    props: ['formData', 'formError'],
};
</script>
